/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APISupplyOrder } from './APISupplyOrder';
import {
    APISupplyOrderFromJSON,
    APISupplyOrderFromJSONTyped,
    APISupplyOrderToJSON,
} from './APISupplyOrder';

/**
 * 
 * @export
 * @interface APIPaginatedSupplyOrderList
 */
export interface APIPaginatedSupplyOrderList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedSupplyOrderList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedSupplyOrderList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedSupplyOrderList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APISupplyOrder>}
     * @memberof APIPaginatedSupplyOrderList
     */
    results: Array<APISupplyOrder>;
}

/**
 * Check if a given object implements the APIPaginatedSupplyOrderList interface.
 */
export function instanceOfAPIPaginatedSupplyOrderList(value: object): value is APIPaginatedSupplyOrderList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedSupplyOrderListFromJSON(json: any): APIPaginatedSupplyOrderList {
    return APIPaginatedSupplyOrderListFromJSONTyped(json, false);
}

export function APIPaginatedSupplyOrderListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedSupplyOrderList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APISupplyOrderFromJSON)),
    };
}

export function APIPaginatedSupplyOrderListToJSON(value?: APIPaginatedSupplyOrderList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APISupplyOrderToJSON)),
    };
}

